import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { observer } from 'mobx-react';
import useStores from 'hooks/use-stores.hooks';
import { useAsyncPromise } from 'hooks/use-async-promise';

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};

const WebsiteLogin: React.FunctionComponent = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { authStore } = useStores();

  useAsyncPromise(async () => {
    try {
      if (!authStore.isAuthenticated) {
        const rawToken = query.get('token');
        if (rawToken) {
          const passedToken = JSON.parse(rawToken);
          await authStore.afterSuccessLogin(passedToken);
        }
      }
    } finally {
      navigate('/', { replace: true });
    }
  }, [authStore, navigate, query]);

  return null;
};

export default observer(WebsiteLogin);
